import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

interface AdminState {
    loading: boolean,
    admin: Object,
    currentUser: Object
    error: string
}

const initialState: AdminState = {
    loading: false,
    admin: {},
    currentUser: {},
    error: ''
}

const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAdminInfo: (state, action) => {
            state.admin = action.payload;
        },
        setCurrentUser: (state, action) => {
            state.currentUser = action.payload;
        },
    }
})

export default adminSlice.reducer
export const { setAdminInfo, setCurrentUser } = adminSlice.actions;
